import {
    useContext,
    type FC
} from "react";
import type IDropdownMenuRadioItemProps from "./type";
import {
    DropdownMenuRadioContext
} from "../../context";
import DropdownMenuMark from "../mark";
import DropdownMenuRow from "../row";

const DropdownMenuRadioItem: FC<IDropdownMenuRadioItemProps> = ({
    isCloseOnSelect = true,
    isDisabled = false,
    customTheme,
    onPress,
    value,
    ...props
}) => {
    const radioContext = useContext(DropdownMenuRadioContext);

    const isChecked = radioContext?.value === value;

    const handlePress = () => {
        radioContext?.onChange?.(value);

        onPress?.();
    };

    return <DropdownMenuRow
        {...props}
        isCloseOnSelect={isCloseOnSelect}
        leading={<DropdownMenuMark
            customTheme={customTheme}
            isDisabled={isDisabled}
            isChecked={isChecked}
            kind="radio"
        />}
        customTheme={customTheme}
        ariaChecked={isChecked}
        isDisabled={isDisabled}
        onPress={handlePress}
        role="menuitemradio"
    />;
};
export default DropdownMenuRadioItem;
